import { useEffect, useState } from 'react';

import { isClientSide } from '@confluence/meta';

export function useElementBySelector(
	selector: string,
	{ disabled = false }: { disabled?: boolean } = {},
): Element | null {
	const [element, setElement] = useState<Element | null>(null);

	useEffect(() => {
		if (!isClientSide()) {
			return;
		}

		if (disabled) {
			return;
		}

		const resolve = () => {
			const next = document.querySelector(selector);
			setElement((current) => (current === next ? current : next));
		};

		resolve();

		const observer = new MutationObserver(resolve);
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => {
			observer.disconnect();
			setElement(null);
		};
	}, [selector, disabled]);

	return element;
}
